import React from 'react';
import { AmlExplanatoryNotes2 } from "../../../reportSections/aml/amlExplanatoryNotes";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { popupActions } from '../../../../store/popupStore';
import { reliabilityActions, RELIABILITY_SECTIONS } from '../../../../store/reliabilityStore';
import { reportActions } from '../../../../store/reportStore';
import { Translate, withLocalize } from 'react-localize-redux';
import AmlRelatedSubjectsEval from '../../aml/amlRelatedSubjectsEval';
import AmlReportDateInformation from "../../../search/aml/amlReportDateInformation";
import AmlReportStatus from './reliabilityAmlStatus';
import BbPopover from '../../../common/popover';
import NoDataComponent from '../../../common/noDataComponent';
import OldStyleSection from '../../../common/oldStyleSection';
import SvgRefresh from "../../../../img/icons/Refresh";

class ReliabilityAmlCheck extends React.Component {

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    componentWillUnmount() {
        this.props.resetCeeAmlData();
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? <NoDataComponent /> : <div>{this.renderContent(this.props.data)}</div>);
    }

    renderContent = (data) => {
        return (
            <AmlReportStatus
                data={this.props.data}
                dataHash={this.props.dataHash}
                onNotRequested={() => this.props.requestFetchSection([this.props.sectionId])}
                onInProgress={() => this.props.requestFetchSection([this.props.sectionId])}
            >
                <div className="aml-available">
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <SvgRefresh className="refresh-icon" />
                            <BbPopover content={this.props.translate("Report.Reliability.Tooltip.UpdateData")} placement="right" targetId="reliability-aml-check-update-data" toggleOnEvent="toggleOnMouse" >
                                <div id="reliability-aml-check-update-data" onClick={() => this.updateData()}>
                                    <span className="link-internal">
                                        <Translate id="Report.Aml.UpdateData" />
                                    </span>
                                </div>
                            </BbPopover>
                        </div>
                        <AmlReportDateInformation inserted={data.insertedFormatted} completed={data.completedFormatted} profile={data.profileName} />
                    </div>
                    <div className="columns is-centered">
                        <div className="column is-12">
                            <OldStyleSection name={this.props.translate("Reliability.SectionTitle.PEP")} hasData={true} isOpen isBold>
                                <div style={{ marginLeft: "2.5em", marginTop: "0.5em" }}>
                                    <AmlRelatedSubjectsEval subjects={data.pepSection.subjects} profiles={data.pepSection.amlRelationProfiles} methodology={data.pepSection.methodology} share={data.pepSection.share} hideRatioFilter={true} />
                                </div>
                            </OldStyleSection>

                            <OldStyleSection name={this.props.translate("Reliability.SectionTitle.SanctionList")} hasData={true} isOpen isBold>
                                <div style={{ marginLeft: "2.5em", marginTop: "0.5em" }}>
                                    <AmlRelatedSubjectsEval subjects={data.otherSection.subjects} profiles={data.otherSection.amlRelationProfiles} methodology={data.otherSection.methodology} share={data.otherSection.share} hideRatioFilter={true} />
                                </div>
                            </OldStyleSection>

                            <AmlExplanatoryNotes2 data={data.pepSection} splitByPep={true} methodology={true} />
                        </div>
                    </div>
                </div>
            </AmlReportStatus>
        )
    }

    updateData = () => this.props.requestCeeAmlData(this.props.id, () => { this.props.requestFetchSection([RELIABILITY_SECTIONS.cee]); this.props.requestFetchSection([RELIABILITY_SECTIONS.aml]) })
}

export default withLocalize(connect(
    state => ({ ...state.report, reliability: state.reliability }),
    dispatch => bindActionCreators(Object.assign({}, reportActions, reliabilityActions, popupActions), dispatch)
)(ReliabilityAmlCheck));